import React, { Component } from "react"
import { connect } from 'react-redux'
import i18n from 'lib/i18n'
import styles from './../documents.scss'
import Uploader from './../../uploader'
//import {UPLOADER_STATE_NEW_POLICY, UPLOADER_STATE_POLICY_FILE, DS_MODULE_CLIENT_CONTRACT} from 'state/constants'

// init translations
const _ = i18n('dswizard')

@connect(
    (state) => {
        return {}
    }
)
export default class UploadLocalDocumentButton extends Component {
    static propTypes = {
        onSelectDocuments: React.PropTypes.func.isRequired,
        moduleType: React.PropTypes.string.isRequired,
        clientId: React.PropTypes.string.isRequired,
        entityId: React.PropTypes.string,
        classNameExtra: React.PropTypes.any,
        claimWizardDocType: React.PropTypes.string,
    }


    render() {
        const { moduleType, clientId, entityId, onSelectDocuments, classNameExtra, claimWizardDocType /*addCommentToPackage*/ } = this.props

        return (<div className={styles.documentsModalButtons}>
            <Uploader
                type={moduleType}
                documents={null}
                id={entityId}
                clientId={clientId}
                forceState={null}
                forceDescription={null}
                onlyUploadButton={true}
                onSelectDocuments={onSelectDocuments}
                disableUploadToOracle={true}
                classNameExtra={classNameExtra}
                claimWizardDocType={claimWizardDocType}
            />
        </div>)
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/UploadLocalDocument/UploadLocalDocumentButton.jsx